<div class="popover-title subtitle-03">
  <div class="popover-title-label-with-icon">
    <mat-icon class="material-symbols-outlined" [inline]="true">
      flag
    </mat-icon>
    <span>{{ dialogTitle }}</span>
  </div>
  <div>
    <ng-content select="[projection-location='header']"></ng-content>
    <button mat-icon-button (click)="panelClose.emit()">
      <mat-icon class="material-symbols-outlined"> close </mat-icon>
    </button>
  </div>
</div>
<h3-scrollable-list>
  <ng-content></ng-content>
</h3-scrollable-list>
